<div class="inner-content" ridangoAppTrapFocus>
    <div class="flex-align-center bottom-0 left-0 right-0 top-0 !flex">
        <div
            class="flex-column flex h-auto w-full rounded-2xl bg-white dark:border-2 dark:border-solid dark:border-contrast-yellow">
            <div class="flex-align-center !flex justify-between border-b border-solid p-4">
                <p class="align-center flex-1 font-semibold">
                    {{ 'SHOPPING_CART_LOCKED_NAVIGATION_MODAL_TITLE' | translate }}
                </p>
                <button
                    class="text-grey-zambezy"
                    [attr.aria-label]="'CLOSE_ARIA_LABEL' | translate"
                    (click)="cancel()"
                    mat-icon-button>
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div class="content overflow-y-auto">
                <ng-container>
                    <div class="shopping-cart-navigation">
                        <div class="shopping-cart-navigation-area">
                            <div class="shopping-cart-navigation-middle">
                                <p>
                                    {{ 'SHOPPING_CART_LOCKED_NAVIGATION_MODAL_TEXT' | translate }}
                                </p>

                                <p class="bold">
                                    {{ 'SHOPPING_CART_LOCKED_NAVIGATION_MODAL_TEXT_BOLD' | translate }}
                                </p>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

            <div class="m-4">
                <button
                    class="flex-align-center sr-app-light:text-primary vl-app-light:text-primary flex h-14 w-full justify-center gap-2 bg-transparent font-bold text-secondary dark:bg-transparent dark:text-contrast-yellow"
                    (click)="cancel()">
                    {{ 'SHOPPING_CART_ABOUT_TO_END_MODAL_CANCEL' | translate }}
                </button>
                <button
                    class="sr-app-light:bg-secondary vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black h-14 w-full rounded-lg bg-primary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                    (click)="confirm()">
                    {{ 'SHOPPING_CART_ALLOW_NAVIGATION' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
